import { useState, useCallback } from 'react';

export const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState({
    show: false,
    message: '',
    type: 'success'
  });

  const showSnackbar = useCallback((message, type = 'success') => {
    setSnackbar({
      show: true,
      message,
      type
    });
  }, []);

  const hideSnackbar = useCallback(() => {
    setSnackbar(prev => ({
      ...prev,
      show: false
    }));
  }, []);

  return {
    snackbar,
    showSnackbar,
    hideSnackbar
  };
};
